import { createSelector } from 'reselect';
import { selectors } from '@saucelabs/sl-util-segmentio';

import { TRACKING_AREA, TRACKING_SUB_AREA_DEFAULT } from '../../tracking';

export const eventMetaDataSelector = createSelector([
  selectors.eventMetaDataSelector,
  (store, options) => options,
], (eventDefaultData, options) => ({
  ...eventDefaultData,
  product_area: TRACKING_AREA,
  product_sub_area: options?.product_sub_area || TRACKING_SUB_AREA_DEFAULT,
}));
